<aurora-icon-button
    id="notificationsButton"
    class="main-menu-button"
    variant="ghost"
    size="xlarge"
    icon="bell"
    label="Notifications"
    [badgeCount]="getUnreadNotificationsCount() || undefined"
>
</aurora-icon-button>

<aurora-popover
    #notifyPopover
    class="notifications-popover-aurora"
    aurora-light
    position="bottom left"
    [showCloseButton]="false"
    (toggle)="onNotificationsPopoverToggle($event)">
    <div class="notifications-popover-content-aurora">
        <sm-global-notifications
            aurora-light
            [settings]="notificationCenter"
            [notificationCards]="notificationCardVMs"
            (onClickLink)="onClickLink($event)"
            (onClose)="handleReadNotifications($event)"
        />
    </div>
</aurora-popover>
